<h1 mat-dialog-title>{{ 'errors.unexpected_error.title' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ data.message | translate }}</p>
  <p>{{ date | date:'dd/MM/yyyy HH:mm:ss:SSS' }}</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>{{ 'close' | translate }}</button>
</div>
